import api from './axios'

/**
 * Forms API
 */
export const formsApi = {
    /**
     * Get all forms (admin only)
     */
    getAll: async () => {
        const response = await api.get('/forms')
        return response
    },

    /**
     * Get single form
     */
    getById: async (id) => {
        const response = await api.get(`/forms/${id}`)
        return response
    },

    /**
     * Get public form (for submission)
     */
    getPublic: async (id) => {
        const response = await api.get(`/forms/${id}/public`)
        return response
    },

    /**
     * Create form
     */
    create: async (data) => {
        const response = await api.post('/forms', data)
        return response
    },

    /**
     * Update form
     */
    update: async (id, data) => {
        const response = await api.put(`/forms/${id}`, data)
        return response
    },

    /**
     * Delete form
     */
    delete: async (id) => {
        const response = await api.delete(`/forms/${id}`)
        return response
    },

    /**
     * Get form statistics
     */
    getStats: async (id) => {
        const response = await api.get(`/forms/${id}/stats`)
        return response
    },
}

export default formsApi
